const fields_data = {
  EN: [
    { key: 'id', label: 'No.', sortable: false, thStyle: 'width: 10%', option : 0 },
    { key: 'is_alive', label: 'Status', sortable: false, thStyle: 'width: 10%', option : 0 },
    { key: 'is_start', label: 'Inspection at registration', sortable: false, thStyle: 'width: 10%', option : 0 },
    { key: 'name', label: 'Name', sortable: false, option : 0 },
    { key: 'fqdn', label: 'FQDN', sortable: false, option : 0 },
    { key: 'schedule', label: 'Schedule', sortable: true, option : 0 },
    { key: 'policy', label: 'Policy Name', sortable: true, option : 0 },
    { key: 'seeds', label: 'URL', sortable: true, option : 1 },
    { key: 'subs', label: 'Sub Domain', sortable: true, option : 2 }, // option 임
    { key: 'prevents', label: 'Exception Path', sortable: true, option : 3 }, // option 임
    { key: 'func', label: 'Action', sortable: false, thStyle: 'width: 10%' , option : 0 },
  ],
  KO: [
    { key: 'id', label: 'No.', sortable: false, thStyle: 'width: 10%', option : 0 },
    { key: 'is_alive', label: '상태', sortable: false, thStyle: 'width: 10%', option : 0 },
    { key: 'is_start', label: '등록과 동시 시작', sortable: false, thStyle: 'width: 10%', option : 0 },
    { key: 'name', label: '이름', sortable: false, option : 0 },
    { key: 'fqdn', label: 'FQDN', sortable: false, option : 0 },
    { key: 'schedule', label: '일정', sortable: true, option : 0 },
    { key: 'policy', label: '정책이름', sortable: true, option : 0 },
    { key: 'seeds', label: 'URL', sortable: true, option : 1 },
    { key: 'subs', label: '서브도메인', sortable: true, option : 2 }, // option 임
    { key: 'prevents', label: '예외경로', sortable: true, option : 3 }, // option 임
    { key: 'func', label: '기능', sortable: false, thStyle: 'width: 10%' , option : 0 },
  ],
  JP : [
    { key: 'id', label: 'No.', sortable: false, thStyle: 'width: 10%', option : 0 },
    { key: 'is_alive', label: 'スターテス', sortable: false, thStyle: 'width: 10%', option : 0 },
    { key: 'is_start', label: '登録時の検査', sortable: false, thStyle: 'width: 10%', option : 0 },
    { key: 'name', label: '名前', sortable: false, option : 0 },
    { key: 'fqdn', label: 'FQDN', sortable: false, option : 0 },
    { key: 'schedule', label: 'スケジュール', sortable: true, option : 0 },
    { key: 'policy', label: 'ポリシー名', sortable: true, option : 0 },
    { key: 'seeds', label: 'URL', sortable: true, option : 1 },
    { key: 'subs', label: 'サブドメイン', sortable: true, option : 2 }, // option 
    { key: 'prevents', label: '例外パス', sortable: true, option : 3 }, // option
    { key: 'func', label: 'アクション', sortable: false, thStyle: 'width: 10%' , option : 0 },
  ]
}

const _i18n_msg = {
  site_name : {
    EN: `no have name name`,
    KO: `no have name name`,
    JP: `名前がありません`
  },
  policy_name : {
    EN: `no have policy name`,
    KO: `no have policy name`,
    JP: `ポリシー名がありません`
  },
  fqdn_name : {
    EN: `no have fqdn name`,
    KO: `no have fqdn name`,
    JP: `FQDN 名がありません`
  },
  schedule_name : {
    EN: `no have schedule name`,
    KO: `no have schedule name`,
    JP: `スケジュール名がありません`
  },
  start_URL : {
    EN: `no have start URL`,
    KO: `no have start URL`,
    JP: `開始 URL がありません`
  }
}

const _i18n_warning = {
  complated : {
    EN: `already complated `,
    KO: `already complated `,
    JP: `すでに完了しました `
  }
}

const _i18n_error = {
  csv_parser : {
    EN: `It is sample file`,
    KO: `It is sample file`,
    JP: `サンプルファイルです`
  },
  stopped : {
    EN: `Stopped`,
    KO: `Stopped`,
    JP: `停止`
  }
}

const _i18n_data = {
  fields_data,
  _i18n_msg,
  _i18n_warning,
  _i18n_error
}

export default _i18n_data